import { render, staticRenderFns } from "./CourseItem.vue?vue&type=template&id=dde03010&scoped=true&"
import script from "./CourseItem.vue?vue&type=script&lang=js&"
export * from "./CourseItem.vue?vue&type=script&lang=js&"
import style0 from "./CourseItem.vue?vue&type=style&index=0&id=dde03010&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde03010",
  null
  
)

export default component.exports